<div id="wrapper">
    <topnavbar></topnavbar>
    <app-navigation *ngIf="!appInfo.hideNav"></app-navigation>
    <div id="page-wrapper" class="d-flex flex-column" [ngClass]="{'no-nav': appInfo.hideNav}">
        <div class="page-main"><router-outlet></router-outlet></div>
        <!-- <footer></footer> -->
    </div>
</div>

<dx-load-panel
    #loadPanel
    message="Please wait..."
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: window }"
    [visible]="pleaseWait()"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="true"
>
</dx-load-panel>
